import { DockerSecurityFormData, DockerSecurityPolicyPayload } from './types';

/**
 * Builds the API payload from form data
 * Wraps values in Directive structure as expected by backend
 */
export function buildDockerSecurityPayload(
  formData: DockerSecurityFormData
): DockerSecurityPolicyPayload {
  return {
    allowBindMountsForRegularUsers: {
      value: formData.allowBindMountsForRegularUsers,
      enforce: false,
    },
    allowPrivilegedModeForRegularUsers: {
      value: formData.allowPrivilegedModeForRegularUsers,
      enforce: false,
    },
    allowHostNamespaceForRegularUsers: {
      value: formData.allowHostNamespaceForRegularUsers,
      enforce: false,
    },
    allowDeviceMappingForRegularUsers: {
      value: formData.allowDeviceMappingForRegularUsers,
      enforce: false,
    },
    allowStackManagementForRegularUsers: {
      value: formData.allowStackManagementForRegularUsers,
      enforce: false,
    },
    allowContainerCapabilitiesForRegularUsers: {
      value: formData.allowContainerCapabilitiesForRegularUsers,
      enforce: false,
    },
    allowSysctlSettingForRegularUsers: {
      value: formData.allowSysctlSettingForRegularUsers,
      enforce: false,
    },
  };
}
